define('modules/auth/forms/views/login.view',[
    'client',
    'jquery',
    'bootstrap',
    'underscore',
    'backbone',
    'modules/base/models/credentials.model',
    'text!modules/auth/forms/templates/login.template.html'
], function(
    Prospector,
    $,Bootstrap,_,Backbone,
    CredentialsModel,
    LoginTemplate
){
    var LoginView = Backbone.View.extend({
        template:_.template(LoginTemplate),
        className: 'loginView container-fluid unAuthView',
        events:function() {
            var base = {
                'keyup #userEmail'      : 'procUpperCase',
                'blur #userEmail'       : 'clearMessages',
                'focus #userEmail'      : 'clearMessages',
                'keyup #userPwd'        : 'procKeyOnEnter'
            };
            var click = {
                'click .btn'           : 'procForm',
                'click .resetPassword' : 'procResetPassword',
                'click .signup'        : 'procSignUp'
            };
            $.extend(base,click);
            return base;
        },
        setURLError :"Login credentials incorrect",
        initialize: function() {
            this.debugName = 'login controller';
            window.login = new CredentialsModel();
            window.auth.fetch();
        },
        render: function() {
            $(this.el).html(this.template());
            this.$('#userNonce').val(window.token.get('nonce'));
            return this;
        },
        procResetPassword:function(){
            window.utils.gaPageTrack('/#reset?nav=login');
        },
        procSignUp:function(){
            window.utils.gaPageTrack('/#signup?nav=login');
        },
        procKeyOnEnter: function(event) {
            var keypressed = event.keyCode || event.which;
            keypressed = (keypressed == 'undefined') ? window.event : keypressed;
            if (keypressed == 13) {
                this.procBeforeLogin();
            }
        },
        procUpperCase: function(event) {
            if (window.utils.validation.isCapsKey(event)) {
                this.$('.loadingMsg').html('E-mail address is case sensitive. Did you mean to enter upper case or have CAPS LOCK enabled?');
            }
        },
        clearMessages: function() {
            this.$('.loadingMsg').html('');
        },
        procForm: function() {
            switch(parseInt(this.$('#formType').val())){
                case 1:
                    this.procBeforeLogin();
                    break;
                default:
            }
        },
        procBeforeLogin: function(){
            window.auth.clear();
            delete $.ajaxSettings.headers["client_id"]; // Remove header before call
            delete $.ajaxSettings.headers["Authorization"]; // Remove header before call

            window.auth.set(
                {
                    userName      : this.$('#userEmail').val().trim()
                }
            );
            window.auth.once('sync', this.saveHost,this);
            window.auth.save();
        },
        saveHost: function(){
            if(window.auth.has('error')){
                this.$('.loadingMsg').html("Error: Invalid Credentials");
                window.login.set({error: undefined, error_description:undefined});
                window.auth.fetch();
            }else if (window.auth.has('name')) {
                window.utils.createCookie("specifiedHost", window.auth.get('name'));
                window.utils.createCookie("userName", window.auth.get('userName'));
                this.procLogin();
            }
        },
        procLogin: function() {
            window.utils.blurForm();
            this.$('.loadingMsg').html('');

            if(window.utils.isChromeExt()){
                this.loginSet(window.utils.CHROME_CLIENT_ID);
                $.ajaxSettings.headers["client_id"] = window.utils.CHROME_CLIENT_ID;
            }else{
                this.loginSet(window.utils.MOBILE_CLIENT_ID_PROD);
                $.ajaxSettings.headers["client_id"] = window.utils.MOBILE_CLIENT_ID_PROD;
            }

            window.login.login();
            if (window.login.isValid()){
                this.$('.loadingMsg').html('Logging in...');
                this.$('.textLoader').addClass('orangeBtnLoader');
                window.login.once('sync', this.procResponse,this);
                window.login.save({wait: true});
            } else {
                this.$('.loadingMsg').html(window.login.errorMessage);
                this.$('.loadingMsg').removeClass('rightLoader');
                window.auth.clear();
                delete window.auth.id;
                window.auth.fetch();
            }
        },
        procResponse: function() {
            if(window.login.has('error')){
                this.$('.loadingMsg').html("Error: Invalid Credentials");
                window.login.set({error: undefined, error_description:undefined});
                window.auth.clear();
                window.auth.fetch();
            }else if (window.login.has('access_token')) {
                this.$('.loadingMsg').html('Revving up our relationship intelligence engines...');
                var passedFunc = $.proxy(function(){
                    Prospector.trigger('login');
                }, this);
                Prospector.trigger('checkUser', {
                    passedFunc: passedFunc
                });
            }
        },
        procToken:function() {
            this.$('#userNonce').val(window.token.get('nonce'));
            this.procLogin();
        },
        loginSet: function(clientId){
            window.login.set(
                {
                    grant_type: "password",
                    client_id: clientId,
                    client_secret: "chrGoogle!92",
                    username   : this.$('#userEmail').val().trim(),
                    password   : this.$('#userPwd').val().trim()
                }
            );
        }
    });
    return LoginView;
});


